'use strict';

var novicell = novicell || {};

novicell.tabs = novicell.tabs || new function () {
    const classActiveNavTab = 'tabs__nav-item--active';
    const classActiveContentTab = 'tabs__pane--active';
    this.init = function(data) {
        const tabsWrappers = document.getElementsByClassName('tabs');
        if(!tabsWrappers.length) {
            return;
        }
        const tabsLinks = document.querySelectorAll('.tabs__nav-link');
        
        for(var i = 0; i < tabsLinks.length; i++){
            tabsLinks[i].addEventListener('click', onTabClick, false);
        }
    };
    //this.onTabClick = function(event) {
    function onTabClick(event) {
        event.preventDefault();
        let currentTabSet = closestByClass(event.target,'tabs');
        if(currentTabSet==null){
            return;
        }
        var activeNavTabs = currentTabSet.getElementsByClassName(classActiveNavTab);
        
        // deactivate existing active tab and panel
        for (var i=0; i < activeNavTabs.length; i++){
            activeNavTabs[i].classList.remove(classActiveNavTab);
        }
        
        var activeContentTabs = currentTabSet.getElementsByClassName(classActiveContentTab);
        
        // deactivate existing active tab and panel
        for (i=0; i < activeContentTabs.length; i++){
            activeContentTabs[i].classList.remove(classActiveContentTab);
        }
        
        // activate new tab and panel
        event.target.parentElement.classList.add(classActiveNavTab);
        currentTabSet.querySelector('#'+event.target.href.split('#')[1]).classList.add(classActiveContentTab);
    }

    function closestByClass (el, clazz) {
        // Traverse the DOM up with a while loop
        while (el.classList == undefined || !el.classList.contains(clazz)) {
            // Increment the loop to the parent node
            el = el.parentNode;
            if (!el ) {
                return null;
            }
        }
        // At this point, the while loop has stopped and `el` represents the element that has
        // the class you specified in the second parameter of the function `clazz`
    
        // Then return the matched element
        return el;
    }
}();